<template>
  <div id="getting-started" class="getting-started">
    <v-toolbar id="custom-toolbar" :flat="!scrolling" app color="transparent">
      <v-toolbar-title>
        <img src="@/assets/cl_logo_white.svg" class="getting-started-logo" />
      </v-toolbar-title>
      <TheHeaderAvatar v-if="isSignedIn" v-bind="{ currentUser, logout }" />
    </v-toolbar>
    <v-content>
      <v-container grid-list-md text-md-center>
        <div class="background-grantient">
          <div class="main-container main-container-top">
            <v-layout row wrap justify-center>
              <v-flex md7>
                <v-card
                  color="transparent"
                  class="white--text main-container__headline"
                  flat
                >
                  <v-card-text class="px-0">
                    <div class="display-1 title-head">
                      Get a Grip on Your Campaign Tracking
                    </div>
                    Enable your team to create tracking links with a simple and
                    customizable url builder. Manage how links are created and
                    maintain a complete history. Free to use and open source.
                  </v-card-text>
                </v-card>
                <v-card
                  color="transparent"
                  class="main-container__buttons"
                  flat
                >
                  <v-btn
                    v-if="isSignedIn"
                    id="google-signin-button"
                    class="default-btn login-button"
                    @click="authorize"
                    >Get Started</v-btn
                  >
                  <v-btn
                    v-else
                    id="google-signin-button"
                    class="default-btn login-button"
                    @click="authorize"
                    ><img src="@/assets/g-logo.png" />Sign in with Google</v-btn
                  >
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div class="main-container main-image-container">
          <v-layout row wrap justify-center>
            <v-flex md8>
              <v-card color="transparent" flat>
                <img
                  src="@/assets/get_started/img1.png"
                  class="example_image example_image1"
                />
              </v-card>
              <v-card color="transparent" flat>
                <v-card-text
                  >You decide what tracking parameters your analytics setup
                  requires and what values your users can use. Every created
                  link is stored in the campaign's history giving you a
                  long-term memory for all your marketing
                  campaigns.</v-card-text
                >
              </v-card>
            </v-flex>
          </v-layout>
        </div>
        <div class="bottom-container">
          <v-layout row wrap justify-center>
            <v-flex md3>
              <v-card color="transparent" flat>
                <img
                  src="@/assets/get_started/img3.png"
                  class="example_image"
                />
              </v-card>
            </v-flex>
            <v-flex md1 hidden-sm-and-down />
            <v-flex md3>
              <v-card color="transparent" flat>
                <v-card-text class="">
                  <div class="display-1">Features</div>
                  <ul>
                    <li v-for="(bulletpoint, i) in bulletpoints" :key="i">
                      <v-icon>check_circle</v-icon>
                      <label>{{ bulletpoint }}</label>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>
              <v-btn color="primary" outline href="/support/" target="_blank"
                >Support</v-btn
              >
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </v-content>

    <v-footer height="auto" color="transparent">
      <v-card class="flex" flat tile>
        <v-card-title class="teal">
          <span class="subheading white--text">
            <span class="subheading__appname"
              >Released under the <strong>GNU GPLv3 License</strong></span
            >
          </span>
          <v-spacer />
          <v-btn
            v-for="(link, title) in links"
            :key="title"
            :href="link"
            class="hidden-sm-and-down white--text"
            flat
            target="_blank"
            >{{ title }}</v-btn
          >
          <v-menu class="hidden-md-and-up">
            <v-toolbar-side-icon slot="activator" class="white--text" />
            <v-list>
              <v-list-tile
                v-for="(link, title) in links"
                :href="link"
                :key="title"
                target="_blank"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-card-title>
      </v-card>
    </v-footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TheHeaderAvatar from "@/components/TheHeaderAvatar";

export default {
  components: {
    TheHeaderAvatar
  },
  data: () => ({
    links: {
      "FAQ's": "/support/faq.html",
      SUPPORT: "/support/"
    },
    bulletpoints: [
      "Separate team or project spaces",
      "Powerful url template editor",
      "Simple text or dropdown inputs",
      "History for all tagged links",
      "Google Accounts sign in",
      "Documented and under active development"
    ],
    scrolling: false,
    containerId: "getting-started"
  }),
  computed: {
    ...mapGetters(["currentUser", "isSignedIn"])
  },
  mounted() {
    if (document.getElementById("custom-toolbar")) {
      document.getElementById("custom-toolbar").style.marginTop = "20px";
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrolling = window.scrollY > 0;
      document.getElementById("custom-toolbar").style.marginTop =
        window.scrollY <= 20 ? 20 - window.scrollY + "px" : "0px";
    },
    authorize() {
      if (this.$store.getters.isSignedIn) {
        this.$router.push("/spaces");
      } else {
        this.$store.dispatch("authorize");
      }
    },
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
</script>

<style lang="scss">
$max-getstarted-width: 1240px;
@-webkit-keyframes rollOut {
  from {
    transform: skewY(0deg);
  }
  to {
    transform: skewY(-5deg);
  }
}
@keyframes rollOut {
  from {
    transform: skewY(0deg);
  }
  to {
    transform: skewY(-5deg);
  }
}
.getting-started {
  font-size: 16px;
  width: 100%;
  margin: 0 auto;
  .v-toolbar {
    @include main_gradient();
    .v-toolbar__content {
      position: relative;
      margin: 0 auto;
      max-width: $max-getstarted-width;
      .v-toolbar__title {
        .getting-started-logo {
          margin-top: 8px;
          width: 300px;
        }
      }
    }
    .the-header-menu {
      position: absolute;
      right: 30px;
    }
  }
  .v-content {
    padding: 0 !important;
    .container {
      max-width: none !important;
      padding: 0;
      .v-card__text {
        padding-left: 0;
        padding-right: 0;
      }
      .v-btn {
        margin: 0;
      }
      .main-container {
        max-width: $max-getstarted-width;
        margin: 0 auto;
        .v-card {
          margin-bottom: 25px;
          .v-card__text {
            padding: 0;
          }
        }
        .v-btn {
          margin-left: 8px;
        }
      }
      .main-container-top {
        .main-container__headline {
          margin-top: 200px;
          text-align: center;
          .title-head {
            margin-bottom: 20px;
            text-align: center;
          }
        }
        .main-container__buttons {
          min-height: 215px;
          margin: 0 auto;
          text-align: center;
        }
      }
      .main-image-container {
        margin-top: -140px;
        margin-bottom: 100px;
      }
      .bottom-container {
        text-align: left;
        .layout {
          margin-bottom: 100px;
        }
        .display-1 {
          color: $theme-primary;
          margin-bottom: 20px;
        }
        ul {
          list-style-type: none;
          margin-left: -2px;
          padding: 0;
          li {
            padding: 0 0 5px 0;
            .v-icon {
              vertical-align: middle;
              color: $theme-primary;
              padding: 0 10px 0 0;
            }
            label {
              vertical-align: middle;
              padding-top: 2px;
            }
          }
        }
      }
      .background-grantient {
        @include main_gradient();
        position: relative;
        &:before {
          content: "";
          @include main_gradient();
          height: 100%;
          position: absolute;
          bottom: 0%;
          transform-origin: bottom right;
          transform: skewY(-5deg); /* MAXIMUM DEPENDS ON CONTAINER HEIGHT */
          /* animation */
          -webkit-animation-name: rollOut;
          animation-name: rollOut;
          animation-duration: 1s;
          -webkit-animation-fill-mode: both;
          animation-fill-mode: both;
        }
      }
      .login-button {
        background-color: #ffffff;
        img {
          width: 20px;
          height: 20px;
          margin-right: 15px;
        }
      }
      img.example_image {
        width: 100%;
        max-width: 100%;
        height: auto;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
          0 6px 20px 0 rgba(0, 0, 0, 0.19);
      }
      /*  fix for IE11 (the images doesn't scale here automatically
          with height: auto, so we need a max width and height) */
      @media screen and (-ms-high-contrast: active),
        screen and (-ms-high-contrast: none) {
        img.example_image {
          max-width: 475px;
          max-height: 341px;
        }
        img.example_image1 {
          max-width: 826px;
          max-height: 527px;
        }
      }
    }
  }
  .v-footer {
    .v-card {
      @include main_gradient();
    }
    .teal {
      max-width: $max-getstarted-width !important;
      border-color: transparent !important;
      background-color: transparent !important;
      height: 150px;
      margin: 0 auto;
      .subheading {
        .v-icon {
          vertical-align: middle;
          font-size: 17px;
          padding-right: 5px;
        }
        span {
          vertical-align: middle;
        }
      }
    }
  }
}
.love-footer {
  bottom: -40px !important;
}
@media (max-width: 960px) {
  .getting-started {
    .main-image-container,
    .bottom-container {
      margin-bottom: 0 !important;
      .layout {
        margin-bottom: 25px !important;
      }
    }
    .main-container {
      margin-bottom: 50px !important;
    }
    .main-container__headline {
      margin-top: 120px !important;
    }
    .main-container__buttons {
      min-height: 180px !important;
      a,
      .v-btn {
        margin-bottom: 10px !important;
      }
    }
    .open_source_container {
      .flex:last-child {
        margin-top: 30px;
      }
    }
    .v-footer {
      .teal {
        height: 80px !important;
      }
    }
  }
}
@media (max-width: 1600px) and (min-width: 960px) {
  .getting-started {
    .flex.md3 {
      flex-basis: 33.33333333333333%;
      -ms-flex-preferred-size: 33.33333333333333%;
      max-width: 33.33333333333333%;
    }
  }
}
@media (max-width: 960px) and (min-width: 400px) {
  .getting-started {
    .flex.md7,
    .flex.md8,
    .flex.md3 {
      flex-basis: 70% !important;
      -ms-flex-preferred-size: 70% !important;
      max-width: 70% !important;
    }
  }
}
@media (max-width: 400px) {
  .getting-started {
    .getting-started-logo {
      width: 250px !important;
    }
    .layout {
      padding: 25px !important;
    }
    .flex.md3 {
      flex-basis: 100%;
      -ms-flex-preferred-size: 100%;
      max-width: 100%;
    }
    .main-image-container,
    .bottom-container {
      margin-bottom: 0 !important;
      .layout {
        margin-bottom: 0px !important;
        padding: 10px;
      }
    }
  }
}
</style>
